import { ProgressSpinner } from "primereact/progressspinner";
import React from "react";

interface TableActionLoaderProps {
    className?: string;
    width?: number;
    height?: number;
    strokeWidth?: string;
}

const TableActionLoader: React.FC<TableActionLoaderProps> = (
    {
        className,
        width = 25,
        height = 25,
        strokeWidth = '6',
    }
) => {
    return (
        <ProgressSpinner
            className={`table_action_loader ${className ?? ''}`}
            style={{ width: `${width}px`, height: `${height}px` }}
            strokeWidth={strokeWidth}
            fill="transparent"
            animationDuration="1s"
        />
    )
}

export default TableActionLoader;